import React, { useState, useEffect, useRef } from 'react';
import theme from "../../theme";
import { DateRangePicker } from 'react-date-range';
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { format } from 'date-fns';
import calenderIcon from '../../assets/icons/calendar.svg'

const formatDate = (date) => {
  return format(date, 'MMM dd, yyyy');
};

const GlobalStyles = createGlobalStyle`
  .rdrSelected, .rdrStartEdge, .rdrEndEdge, .rdrInRange {
    background: ${theme.color.brandDark} !important;
  }
  .rdrDateDisplayItemActive {
    border-color: ${theme.color.brandDark} !important;
}
.rdrStaticRangeSelected {
  color: ${theme.color.brandDark} !important;
}
.rdrDayToday .rdrDayNumber span:after{
    background: ${theme.color.brandDark} !important;
  }
  .rdrDayStartPreview {
  border-left: 1px solid ${theme.color.brandDark} !important;
  border-top: 1px solid ${theme.color.brandDark} !important;
  border-bottom: 1px solid ${theme.color.brandDark} !important;
}
.rdrDayEndPreview {
  border-right: 1px solid ${theme.color.brandDark} !important;
  border-top: 1px solid ${theme.color.brandDark} !important;
  border-bottom: 1px solid ${theme.color.brandDark} !important;
}
.rdrDayInPreview {
  border-top: 1px solid ${theme.color.brandDark} !important;
  border-bottom: 1px solid ${theme.color.brandDark} !important;
}
.rdrDayHovered {
  border: none !important;
}
`;

const DateRangePickerWrapper = styled.div`
  position: relative;
  display: inline-block;

  .date-display {
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border: 1px solid #989FAD;
    border-radius: 12px;
    cursor: pointer;
    color: #48505E;
    font-size: 14px;

    .icon {
      margin-right: 8px;
    }
  }

  .date-picker {
    position: absolute;
    top: 50px;
    right: 10px;
    z-index: 1000;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    display: ${props => (props.showPicker ? 'block' : 'none')};
  }
`;

const DateRangePickerComponent = ({ onDateChange }) => {
  const [state, setState] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection'
    }
  ]);
  const [showPicker, setShowPicker] = useState(false);
  const wrapperRef = useRef(null);

  const handleRangeChange = (ranges) => {
    setState([ranges.selection]);
    onDateChange({
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate,
    });
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    // Add event listener to detect outside clicks
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
    <GlobalStyles />
    <DateRangePickerWrapper ref={wrapperRef} showPicker={showPicker}>
      <div
        className="date-display"
        onClick={() => setShowPicker(!showPicker)}
      >
        <span className="icon"><img src={calenderIcon} alt="" /></span>
        <span>{`${formatDate(state[0].startDate)} - ${formatDate(state[0].endDate)}`}</span>
      </div>

      <div className="date-picker">
        <DateRangePicker
          ranges={state}
          onChange={handleRangeChange}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={2}
          maxDate={addDays(state[0].startDate, 7)}
          direction="vertical"
        />
      </div>
    </DateRangePickerWrapper>
    </>
  );
};

export default DateRangePickerComponent;
